import { render, staticRenderFns } from "./PlanTable2.vue?vue&type=template&id=33950059&scoped=true&"
import script from "./PlanTable2.vue?vue&type=script&lang=js&"
export * from "./PlanTable2.vue?vue&type=script&lang=js&"
import style0 from "./PlanTable2.vue?vue&type=style&index=0&id=33950059&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33950059",
  null
  
)

export default component.exports